import { ServerConfig } from "@/config/config";
import { AllMetrics } from "@/models/metrics";
import { Axios } from "@/services/auth-service";
import { ActiveUsersList } from "@/utils/active-users-list";
import Vue from "vue";
import { MainSocketService } from "./main-socket-service";
import { ActiveUser } from "@/utils/active-user";
import { ActiveUserSessionInfo } from "@/utils/active-user-session-info";
import {RunningJob} from "@/utils/running-job";
import { DbInfo } from "@/models/db-info";

export const MetricService = new Vue({
	data() {
		return {
			allMetrics: new AllMetrics()
		};
	},
	computed: {
		url():string {
			return ServerConfig.mainAppHost + "/metrics";
		}
	},
	methods: {
		async getMetrics():Promise<AllMetrics> {
			let result = await Axios.get(this.url);
			this.allMetrics = new AllMetrics(result.data);
			return this.allMetrics;
		},
		subscribeToEvents() {
			MainSocketService.on("/metrics", (data:any) => {
				this.allMetrics = new AllMetrics(data);
			});
		},
		async getActiveUsers(limit:number, page:number):Promise<ActiveUsersList>{
			let result = await Axios.get(`${this.url}/online-users`, {
				params: {
					limit,
					offset: limit * (page-1),
				}
			});
			return new ActiveUsersList(result.data.map((d:any)=>new ActiveUser(d)));
		},
		async getActiveUserSessionInfo(userId:number):Promise<ActiveUserSessionInfo[]>{
			let result = await Axios.get(`${this.url}/online-users/${userId}`);
			return ((result.data || []) as any[]).map(d=>new ActiveUserSessionInfo(d));
		},
		async getRunningJobs():Promise<RunningJob[]>{
			let result = await Axios.get(`${this.url}/running-jobs`);
			return ((result.data || []) as any[]).map(j=>new RunningJob(j));
		},
		async getAllDbIds():Promise<DbInfo[]>{
			let result = await Axios.get(`${this.url}/available-dbs`);
			return (result.data || []).map((d:any)=>new DbInfo(d));
		}
	},
	created() {
		this.subscribeToEvents();
	}
});